export default class Socials {
    activeClass = "js-sticky";

    init = () => {
        $(window).scroll(() => {
            let scroll = $(window).scrollTop();

            if (scroll >= this.node.scrollTop()){
                this.node.css({top: `${scroll}px`});
            }else {
                this.node.css({top: ''});
            }
        })
    }

    constructor(node) {
        this.node = $(node);
        console.log(this.node);
        this.init();
    }
}



// WEBPACK FOOTER //
// ./app/blocks/socials/socials.js